import { setCookie, getCookie } from "@/utils/cookie";

import { setLocalStorage, getLocalStorage } from "@/utils/local-storage";

import moment from "moment";

const INSURANCE_LIST_HEADER_KEY = "oiais_insurance_list";

export const state = () => ({
  selected_headers: [
    //已選的列表表頭
    {
      text: "保單號碼",
      align: "start",
      sortable: false,
      value: "insurance_number",
      width: "80px",
      selected: true,
    },
    {
      text: "業務員",
      sortable: false,
      value: "salesman_name",
      width: "100px",
      selected: true,
    },
    {
      text: "投保人姓名",
      sortable: false,
      value: "holder_name",
      width: "100px",
      selected: true,
    },
    {
      text: "保險公司",
      sortable: false,
      value: "insurance_company_name",
      width: "100px",
      selected: true,
    },
    {
      text: "產品名稱",
      sortable: false,
      value: "insurance_product_name",
      width: "100px",
      selected: true,
    },
    {
      text: "保費",
      sortable: false,
      value: "period_fee",
      width: "80px",
      selected: true,
    },
    {
      text: "供款年期",
      sortable: false,
      value: "contribution_period",
      width: "50px",
      selected: true,
    },
    {
      text: "投保日期",
      sortable: false,
      value: "insured_date",
      width: "100px",
      selected: true,
    },
    {
      text: "供款期滿日期",
      sortable: false,
      value: "effective_date",
      width: "100px",
      selected: true,
    },
    {
      text: "受益人姓名",
      sortable: false,
      value: "beneficiary_name",
      width: "150px",
      selected: true,
    },
    {
      text: "資料操作",
      sortable: false,
      value: "actions",
      width: "50px",
      selected: true,
    },
  ],
  total_headers: [
    //可選的列表表頭
    {
      text: "保單號碼",
      align: "start",
      sortable: false,
      value: "insurance_number",
      width: "80px",
      selected: true,
    },
    {
      text: "業務員",
      sortable: false,
      value: "salesman_name",
      width: "100px",
      selected: true,
    },
    {
      text: "投保人姓名",
      sortable: false,
      value: "holder_name",
      width: "100px",
      selected: true,
    },
    {
      text: "保險公司",
      sortable: false,
      value: "insurance_company_name",
      width: "100px",
      selected: true,
    },
    {
      text: "產品名稱",
      sortable: false,
      value: "insurance_product_name",
      width: "100px",
      selected: true,
    },
    {
      text: "保費",
      sortable: false,
      value: "period_fee",
      width: "80px",
      selected: true,
    },
    {
      text: "幣別",
      sortable: false,
      value: "currency_type",
      width: "50px",
      selected: false,
    },
    {
      text: "供款年期",
      sortable: false,
      value: "contribution_period",
      width: "50px",
      selected: true,
    },
    {
      text: "投保日期",
      sortable: false,
      value: "insured_date",
      width: "100px",
      selected: true,
    },
    {
      text: "供款期滿日期",
      sortable: false,
      value: "effective_date",
      width: "100px",
      selected: true,
    },
    {
      text: "受益人姓名",
      sortable: false,
      value: "beneficiary_name",
      width: "150px",
      selected: true,
    },
    {
      text: "被保險人姓名",
      sortable: false,
      value: "insured_name",
      width: "150px",
      selected: false,
    },
    {
      text: "第二持有人姓名",
      sortable: false,
      value: "second_holder_name",
      width: "150px",
      selected: false,
    },
    {
      text: "後備受保人姓名",
      sortable: false,
      value: "backup_holder_name",
      width: "150px",
      selected: false,
    },
    {
      text: "失去行動能力權益人士",
      sortable: false,
      value: "loss_of_mobility",
      width: "150px",
      selected: false,
    },
    {
      text: "代理商",
      sortable: false,
      value: "agency_company_name",
      width: "100px",
      selected: false,
    },
    //{ text: "資料操作", sortable: false, value: "actions" , width: '50px'},
  ],
});

export const getters = {
  getSelectedHeaders(state) {
    var headers =
      state.selected_headers ||
      getCookie(INSURANCE_LIST_HEADER_KEY) ||
      getLocalStorage(INSURANCE_LIST_HEADER_KEY);
    if (headers == null) headers = [];
    if (headers != []) {
      if (state.selected_headers == []) {
        state.selected_headers = headers;
      }
    }
    return state.selected_headers;
  },
  getAllHeaders: (state) => state.total_headers,
};

export const mutations = {
  setSelectedHeaders(state, payload) {
    state.selected_headers = payload;
    state.selected_headers.push({
      text: "資料操作",
      sortable: false,
      value: "actions",
      width: "50px",
    });
    const now = moment();
    const expiredAt = now.add(18, "hours");
    setCookie({
      name: INSURANCE_LIST_HEADER_KEY,
      value: payload,
      expiredAt: expiredAt,
    });
    //把token放到LocalStorage
    setLocalStorage({
      name: INSURANCE_LIST_HEADER_KEY,
      value: payload,
    });
  },
};
